import React from "react"
import PropTypes from "prop-types"

import CheckSvg from "./svg/check.svg"
import DragSvg from "./svg/drag.svg"
import PlusSvg from "./svg/plus.svg"
import TrashSvg from "./svg/trash.svg"

function Icon({ name, width, height, color, ...props }) {
  const icons = {
    check: CheckSvg,
    drag: DragSvg,
    trash: TrashSvg,
    plus: PlusSvg,
  }
  const SvgIcon = icons[name]
  return (
    <span className="icon" {...props} css={{ display: "inline-block" }}>
      <SvgIcon stroke={color} width={width} height={height} fill="none" />
    </span>
  )
}

Icon.propTypes = {
  color: PropTypes.string,
  name: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
}

export default Icon
